import styled from 'styled-components'
import { darkOrange, orange } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'

/** The tile thumbnail expanded as the popup's visual anchor. */
export const HeroImage = styled.img`
	width: 100%;
	max-height: 280px;
	object-fit: cover;
	border-radius: ${radii.inner};
	display: block;
`

export const DetailStack = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-top: 16px;
`

export const CategoryBadge = styled.span`
	align-self: flex-start;
	background: ${orange}14;
	color: ${darkOrange};
	font-size: ${fontSizes.caption};
	font-weight: 700;
	padding: 4px 10px;
	border-radius: ${radii.small};
`
